module.exports = __webpack_public_path__ + "fonts/iconfont.3ff889c.woff2";